import classNames from 'classnames';

interface TaskStatusTodoIconProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
}

function TaskStatusTodoIcon({ size = 32, className = '', ...props }: TaskStatusTodoIconProps) {
  return (
    <div className={classNames(className, 'text-black')} {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 56 56'
        fill='none'
      >
        <path
          d='M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z'
          fill='#8E8E93'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M42.2765 16.3905C42.7972 16.9112 42.7972 17.7554 42.2765 18.2761L28.9431 31.6095C28.4224 32.1302 27.5782 32.1302 27.0575 31.6095L23.0575 27.6095C22.5368 27.0888 22.5368 26.2446 23.0575 25.7239C23.5782 25.2032 24.4224 25.2032 24.9431 25.7239L28.0003 28.781L40.3909 16.3905C40.9115 15.8698 41.7558 15.8698 42.2765 16.3905Z'
          fill='#161616'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.667 17.3327C18.3134 17.3327 17.9742 17.4732 17.7242 17.7232C17.4741 17.9733 17.3337 18.3124 17.3337 18.666V37.3327C17.3337 37.6863 17.4741 38.0254 17.7242 38.2755C17.9742 38.5255 18.3134 38.666 18.667 38.666H37.3337C37.6873 38.666 38.0264 38.5255 38.2765 38.2755C38.5265 38.0254 38.667 37.6863 38.667 37.3327V27.9993C38.667 27.263 39.2639 26.666 40.0003 26.666C40.7367 26.666 41.3337 27.263 41.3337 27.9993V37.3327C41.3337 38.3936 40.9122 39.411 40.1621 40.1611C39.4119 40.9113 38.3945 41.3327 37.3337 41.3327H18.667C17.6061 41.3327 16.5887 40.9113 15.8386 40.1611C15.0884 39.411 14.667 38.3936 14.667 37.3327V18.666C14.667 17.6051 15.0884 16.5877 15.8386 15.8376C16.5887 15.0874 17.6061 14.666 18.667 14.666H33.3337C34.07 14.666 34.667 15.263 34.667 15.9993C34.667 16.7357 34.07 17.3327 33.3337 17.3327H18.667Z'
          fill='#161616'
        />
      </svg>
    </div>
  );
}

export default TaskStatusTodoIcon;
